import React, { useMemo } from 'react'
import useBoardDataProvider from './useBoardDataProvider'
import BoardContext from './BoardContext'

type Props = {
  children: (props: ReturnType<typeof useBoardDataProvider>) => React.ReactNode
} & Parameters<typeof useBoardDataProvider>[0]

const BoardDataProvider: React.FC<Props> = ({ children, ...props }) => {
  const boardContextValue = useMemo(() => ({
    id: props.id || 0
  }), [props.id])

  const childrenProps = useBoardDataProvider(props)

  return (
    <BoardContext.Provider value={boardContextValue}>
      {children(childrenProps)}
    </BoardContext.Provider>
  )
}

export default BoardDataProvider
